export default "<p>\n  {{ timeRemaining$ | async | date:'mm:ss' }}\n</p>\n"